/**
 * Date-extensions locale Swedish [sv]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('sv', {
    monthNames: ['Januari','Februari','Mars','April','Maj','Juni','Juli','Augusti','September','Oktober','November','December'],
    monthShortNames: ['Jan','Feb','Mar','Apr','Maj','Jun','Jul','Aug','Sep','Okt','Nov','Dec'],
    dayNames: ['Söndag','Måndag','Tisdag','Onsdag','Torsdag','Fredag','Lördag'],
    dayShortNames: ['Sön','Mån','Tis','Ons','Tor','Fre','Lör']
});
